import React from 'react';
import { getDriverAge, getDriverYearsRaced, getFormattedDriverDOB, getFormattedDriverDOD } from './Utils';

const FeaturedDriver = ({ driver }) => {
    const {
        featuredImage,
        title,
        country,
        currentTeam,
        recentRace,
        permalink,
        recentRaceUrl,
        currentTeamUrl,
    } = driver._source;

    let imageUrl = featuredImage ?? false;

    if (imageUrl === false || imageUrl.includes('images/media/default.png')) {
        imageUrl = `${theme_details.templateUrl}/images/motorsport-icon.png`;
    }

    const died = ('dateOfDeath' in driver._source && driver._source.dateOfDeath !== '') || 
        ('yearOfDeath' in driver._source && driver._source.yearOfDeath !== '') || 
        ('yearOfDeathCirca' in driver._source && driver._source.yearOfDeathCirca !== '');

    return (
        <div className="database-stat database-stat--featured-driver">
            <div className="database-stat__content">
                <div className="database-stat__inner">
                    {imageUrl && (
                        <div className="database-stat__image circular-image">
                            <img src={imageUrl} alt={`Driver image for ${title}`} />
                        </div>
                    )}
                    <h4 className="database-stat__inner-title">{title}</h4>
                    <ul className="database-stat__driver-details">
                        <li className="driver-detail">
                            <h5 className="driver-detail__heading proxima">Born</h5>
                            <p className="driver-detail__value proxima">
                                {getFormattedDriverDOB(driver)}
                                {!died && <>
                                    &nbsp;(AGE {getDriverAge(driver)})
                                </>
                            }
                            </p>
                        </li>
                        {died && (
                            <li className="driver-detail">
                                <h5 className="driver-detail__heading proxima">Died</h5>
                                <p className="driver-detail__value proxima">
                                    {getFormattedDriverDOD(driver)} (AGE {getDriverAge(driver)})
                                </p>
                            </li>
                        )}
                        <li className="driver-detail">
                            <h5 className="driver-detail__heading proxima">Nationality</h5>
                            <p className="driver-detail__value proxima">
                                <img
                                    src={`${theme_details.templateUrl}/svgs/${country}.svg`}
                                    width="34"
                                    height="42"
                                    alt={country}
                                    title={country}
                                />
                                {country.toUpperCase()}
                            </p>
                        </li>
                        <li className="driver-detail">
                            <h5 className="driver-detail__heading proxima">Team</h5>
                            <p className="driver-detail__value proxima">
                                <a href={currentTeamUrl}>{currentTeam}</a>
                            </p>
                        </li>
                        <li className="driver-detail">
                            <h5 className="driver-detail__heading proxima">Years in Database</h5>
                            <p className="driver-detail__value proxima">{getDriverYearsRaced(driver)}</p>
                        </li>
                        <li className="driver-detail">
                            <h5 className="driver-detail__heading proxima">Recent race</h5>
                            <p className="driver-detail__value proxima">
                                <a href={recentRaceUrl}>{recentRace}</a>
                            </p>
                        </li>
                    </ul>
                    <a className="button button--outline" href={permalink}>
                        View full driver bio
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FeaturedDriver;
